import { render, staticRenderFns } from "./ActiveAccountReport.vue?vue&type=template&id=2c18ada3&scoped=true&"
import script from "./ActiveAccountReport.vue?vue&type=script&lang=js&"
export * from "./ActiveAccountReport.vue?vue&type=script&lang=js&"
import style0 from "./ActiveAccountReport.vue?vue&type=style&index=0&id=2c18ada3&lang=scss&scoped=true&"
import style1 from "./ActiveAccountReport.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c18ada3",
  null
  
)

export default component.exports